import { render, staticRenderFns } from "./CustomButtonList.vue?vue&type=template&id=06d7d12b"
import script from "./CustomButtonList.vue?vue&type=script&lang=ts"
export * from "./CustomButtonList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d7d12b')) {
      api.createRecord('06d7d12b', component.options)
    } else {
      api.reload('06d7d12b', component.options)
    }
    module.hot.accept("./CustomButtonList.vue?vue&type=template&id=06d7d12b", function () {
      api.rerender('06d7d12b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/CustomButtonList.vue"
export default component.exports